/* Buena Vita — homepage behaviour: scroll reveals + FAQ accordion.
   Kept dependency-free so it cannot break when the theme's own JS changes. */
(function () {
  'use strict';

  // Every bv-* section requests this file, so guard against running twice.
  if (window.__bvHomeInit) return;
  window.__bvHomeInit = true;

  var root = document.documentElement;
  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Gate the hidden state on this class so a JS failure can never leave the
  // page blank. See the matching comment in bv-home.css.
  if (!reduced && 'IntersectionObserver' in window) {
    root.classList.add('bv-anim');
  }

  function revealAll(scope) {
    var nodes = (scope || document).querySelectorAll('.bv-reveal:not(.is-in)');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  function initReveals(scope) {
    if (!root.classList.contains('bv-anim')) return;

    var targets = (scope || document).querySelectorAll('.bv-reveal:not(.is-in)');
    if (!targets.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    for (var i = 0; i < targets.length; i++) io.observe(targets[i]);
  }

  function initFaq(scope) {
    var buttons = (scope || document).querySelectorAll('.bv-faq__q');

    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        if (btn.dataset.bvBound === '1') return;
        btn.dataset.bvBound = '1';

        btn.addEventListener('click', function () {
          var item = btn.closest('.bv-faq__item');
          if (!item) return;

          var list = item.closest('.bv-faq__list');
          var willOpen = !item.classList.contains('is-open');

          // One open at a time keeps the section from jumping around.
          if (willOpen && list) {
            var open = list.querySelectorAll('.bv-faq__item.is-open');
            for (var j = 0; j < open.length; j++) {
              open[j].classList.remove('is-open');
              var b = open[j].querySelector('.bv-faq__q');
              if (b) b.setAttribute('aria-expanded', 'false');
            }
          }

          item.classList.toggle('is-open', willOpen);
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      })(buttons[i]);
    }
  }

  function init(scope) {
    initReveals(scope);
    initFaq(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // The theme editor swaps section markup in without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    revealAll(event.target);
  });
})();
